import { Reveal, SectionHead } from "../motion";
import { EXPERTISE } from "../../content";

export function Expertise() {
  return (
    <section id="expertise" data-testid="expertise-section" className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20 lg:py-24">
      <SectionHead
        eyebrow="Expertise"
        title="Areas of Expertise"
        intro="My work covers AML and financial crime, regulatory compliance, contracts and in-house legal and compliance operations, with a focus on practical implementation."
      />
      <div className="mt-10 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3">
        {EXPERTISE.map((item, i) => (
          <Reveal key={item.title} delay={0.06 * i}>
            <article
              data-testid={`expertise-card-${i}`}
              className="group h-full rounded-sm border border-ink/10 bg-warmwhite p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-gold hover:shadow-[0_18px_40px_-24px_rgba(123,30,58,0.35)] sm:p-7"
            >
              <p className="font-display text-sm italic text-gold">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-3 font-display text-xl leading-snug text-ink transition-colors duration-300 group-hover:text-cherry">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/65">{item.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
